(function () {
  function initTimeline(root) {
    var titleEl = root.querySelector('.static-timeline__center-title');
    var titleText = titleEl ? titleEl.querySelector('span') : null;
    var titleLink = titleEl ? titleEl.querySelector('.static-timeline__center-link') : null;
     var text = titleEl ? titleEl.querySelector('.static-timeline__center-text') : null;
    var panels = root.querySelectorAll('[data-panel]');
    var navEl = root.querySelector('[data-panel-nav]');

    if (!panels.length || !navEl) return;

    var currentActive = null;
    var swapTimeout = null;

    panels.forEach(function (panel) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.dataset.target = panel.dataset.panelId;
      btn.setAttribute('aria-label', panel.dataset.title || '');
      btn.innerHTML =
        '<span class="static-timeline__dot"></span><span class="static-timeline__label">' +
        (panel.dataset.title || '') +
        '</span>';

      btn.addEventListener('click', function () {
        panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      navEl.appendChild(btn);
    });

    var navButtons = navEl.querySelectorAll('button');

    function setActiveNav(panel) {
      navButtons.forEach(function (btn) {
        btn.classList.toggle('active', btn.dataset.target === panel.dataset.panelId);
      });
    }

    var panelObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var panel = entry.target;

          if (entry.isIntersecting) {
            panel.classList.add('active');

            if (currentActive !== panel) {
              currentActive = panel;
              setActiveNav(panel);
              clearTimeout(swapTimeout);
              if (titleEl) titleEl.classList.remove('visible');
              swapTimeout = setTimeout(function () {
                if (titleText) titleText.textContent = panel.dataset.title || '';
                if (titleLink) {
                  titleLink.textContent = panel.dataset.linkText || '';
                  titleLink.href = panel.dataset.linkUrl || '#';
                }
                if (text) {
                  var textSource = panel.querySelector('.static-timeline__panel-text');
                  text.innerHTML = textSource ? textSource.innerHTML : '';
                }
                if (titleEl) titleEl.classList.add('visible');
              }, 300);
            }
          } else {
            panel.classList.remove('active');
          }
        });
      },
      {
        root: null,
        rootMargin: '-45% 0px -45% 0px',
        threshold: 0,
      }
    );

    panels.forEach(function (panel) {
      panelObserver.observe(panel);
    });

    var navOffset = parseFloat(getComputedStyle(navEl).bottom) || 0;
    var dockTicking = false;

    function updateDock() {
      var rect = root.getBoundingClientRect();
      root.classList.toggle('static-timeline--docked', rect.bottom <= window.innerHeight - navOffset);
      dockTicking = false;
    }

    function requestDockUpdate() {
      if (!dockTicking) {
        dockTicking = true;
        requestAnimationFrame(updateDock);
      }
    }

    window.addEventListener('scroll', requestDockUpdate, { passive: true });
    window.addEventListener('resize', requestDockUpdate);
    requestDockUpdate();
  }

  function init() {
    document.querySelectorAll('.static-timeline').forEach(initTimeline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
